import { Directive, Input, TemplateRef } from '@angular/core';
import { Placement } from '@epicuro-next/utilities';

@Directive()
export abstract class PopoverDirectiveInputs {
  /**
   * Popover close condition.
   * If true will close on ouside and inside popover click.
   * On 'ouside' will close popover only if click happend on backdrop.
   * On 'inside' will close popover only if click happend inside popover.
   */
  @Input()
  public autoClose: boolean | 'inside' | 'outside' = true;

  /** Popover body */
  @Input()
  public atxPopover: string | TemplateRef<unknown>;

  /** Popover title */
  @Input()
  public popoverTitle?: string | TemplateRef<unknown>;

  /** Popover placement */
  @Input()
  public popoverPlacement: Placement = Placement.BOTTOM_LEFT;

  /** Popover open triggers */
  @Input()
  public triggers: 'click' | 'hover' | 'manual' = 'click';

  /** Popover open triggers */
  @Input()
  public hoverAutoClose = true;

  /** Popover content is full width at source element borders. */
  @Input()
  public stickWithFullWidth = false;

  /** Class applied on panel container */
  @Input()
  public panelClass?: string;

  /** Class applied on popover */
  @Input()
  public componentClass?: string;

  /** Class applied on backdrop */
  @Input()
  public backdropClass = '';

  @Input()
  public closeOnScroll = true;

  @Input()
  public hasBackdrop = true;

  @Input()
  public popoverEnabled = true;
}
